import { campusByID } from '../constants/campuses';

const addOrRemove = (arr, item) =>
  arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];

export default function appReducer(state, action) {
  switch (action.type) {
    case 'INITIALIZE_REDUCER':
      return action.payload;

    case 'UPDATE_MAP':
      return Object.assign({}, state, action.payload);

    case 'SET_MAP_CENTER':
      return Object.assign({}, state, {
        center: action.payload,
      });

    case 'SET_CAMPUS':
      const { id, lat, lng } = campusByID(action.payload);
      return Object.assign({}, state, {
        campus: id,
        center: { lat, lng },
        zoom: id === 'swc' ? 13 : 17, // Set default zoom to 13 for SWC campus
      });

    case 'OPEN_MARKERS_DIALOG':
    case 'CLOSE_MARKERS_DIALOG':
      return Object.assign({}, state, {
        isMarkersDialogOpen: action.payload,
      });

    case 'TOGGLE_MARKER':
      const selectedMarkers = addOrRemove(
        state.selectedMarkers,
        action.payload
      );
      return Object.assign({}, state, { selectedMarkers });

    default:
      return state;
  }
}
